/* eslint-disable no-shadow */
/* eslint-disable no-nested-ternary */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-param-reassign */

import AffiliateApi from '@/services/affiliatedData';
import ReportLastAccessApi from '@/services/reportLastAccess';
import LabelsApi from '@/services/labels';
import SecurityApi from '@/services/security';
import SitesApi from '@/services/sites';
import BlockedUrls from '@/services/blockedUrls';

const state = {
  info: null,
  advertisers: [],
  campaigns: [],
  urls: [],
  blockedUrls: [],
  labels: [],
  isAuthenticated: false,
  approvedUrlsByIdt: [],
  isAnyUrlApproved: true,
  lastAccessPath: '',
};

const getters = {
  affiliateInfo: currentState => currentState.info,
  affiliateCampaigns: currentState => currentState.campaigns,
  affiliateAdvertisers: currentState => currentState.advertisers,
  approvedAdvertisers: currentState => currentState.advertisers
    .filter(advertiser => advertiser.indStatus === 'A'),
  affiliateUrls: currentState => currentState.urls,
  approvedUrls: currentState => currentState.urls
    .filter(url => url.indStatus === 'APPROVED'),
  affiliateBlockedUrls: currentState => currentState.blockedUrls,
  affiliateLabels: currentState => currentState.labels.filter(label => label.indStatus !== 'INACTIVE'),
  affiliateIsAuthenticated: currentState => currentState.isAuthenticated,
  approvedUrlsByIdt: currentState => currentState.approvedUrlsByIdt,
  isAnyUrlApproved: currentState => currentState.isAnyUrlApproved,
  lastAccessPath: currentState => currentState.lastAccessPath,
};

const actions = {
  async fetchAffiliateData({ commit }) {
    const affiliateData = await AffiliateApi.getAffiliatedData();
    commit('setAffiliateData', affiliateData);
  },
  async createLabel({ commit }, desLabel) {
    const response = await LabelsApi.createLabel(desLabel);
    commit('addLabel', {
      idtUserSupplierLabel: response.labels[0].idtUserSupplierLabel,
      desLabel: response.labels[0].desLabel,
    });
  },
  async deleteLabel({ commit }, label) {
    await LabelsApi.deleteLabel(label);
    commit('removeLabel', label);
  },
  async checkAuthentication({ commit }) {
    try {
      await SecurityApi.isAuth();
      commit('setIsAuthenticated', true);
    } catch (error) {
      commit('setIsAuthenticated', false);
    }
  },
  async updateToFavorite({ commit, state }, site) {
    const urls = JSON.parse(JSON.stringify(state.urls));
    try {
      commit('updateSiteToFavorite', site);
      await SitesApi.favoriteSite(site);
    } catch (error) {
      commit('setUrls', urls);
      throw error;
    }
  },
  async getBlockedUrls({ commit }) {
    const urlsBlocked = await BlockedUrls.getBlockedUrls();
    commit('setBlockedUrls', urlsBlocked);
  },
  getApprovedUrlsByIdt({ commit, state }, idt) {
    const urlsByIdt = idt ? state.urls.filter(url => url.isApprovedTo)
      .filter(url => url.isApprovedTo[0].split(',').includes(idt)) : state.urls;
    commit('setApprovedUrlsByIdt', urlsByIdt);
  },
  setLastAccessPage({ commit }, path) {
    ReportLastAccessApi.updateLastAccessAffiliatedData(path);
    commit('setLastAccessPage', path);
  },
};

const mutations = {
  setAffiliateData: (currentState, affiliateData) => {
    const isAnyApproved = affiliateData.affiliatedData.urlStatus.indexOf('A') > -1;
    currentState.info = affiliateData.affiliatedData;
    currentState.advertisers = affiliateData.affiliatedData.sourceGroupList;
    currentState.campaigns = affiliateData.affiliatedData.campaigns;
    currentState.urls = affiliateData.affiliatedLists.urls;
    currentState.labels = affiliateData.affiliatedLists.labels;
    currentState.isAnyUrlApproved = isAnyApproved;
  },
  addLabel: (currentState, newLabel) => {
    currentState.labels = [...currentState.labels, newLabel];
  },
  removeLabel: (currentState, labelRequest) => {
    currentState.labels = currentState.labels.filter(
      label => label.idtUserSupplierLabel !== labelRequest.value,
    );
  },
  updateSiteToFavorite: (currentState, site) => {
    currentState.urls.map((s) => {
      if (s.idtUserSupplierUrl === site.idtUserSupplierUrl) {
        s.isFavorite = '1';
      } else {
        s.isFavorite = '0';
      }
      return s;
    });
    const index = currentState.urls.findIndex(x => x.isFavorite === '1');
    const urlObject = currentState.urls.find(x => x.isFavorite === '1');
    currentState.urls = Array.prototype.slice.call(currentState.urls);
    currentState.urls.unshift(urlObject);
    currentState.urls.splice(index + 1, 1);
  },
  setIsAuthenticated: (currentState, isAuthenticated) => {
    currentState.isAuthenticated = isAuthenticated;
  },
  setBlockedUrls: (currentState, blockedUrls) => {
    currentState.blockedUrls = blockedUrls;
  },
  setUrls: (currentState, urls) => {
    currentState.urls = urls;
  },
  setApprovedUrlsByIdt: (currentState, urls) => {
    currentState.approvedUrlsByIdt = urls;
  },
  setLastAccessPage: (currentState, path) => {
    currentState.lastAccessPath = path;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
